require("./bootstrap");

// window.Vue = require("vue");
import Vue from "vue";
import VuePluralize from "vue-pluralize";
import { ServerTable } from "vue-tables-2";
import Notifications from "vue-notification";
import Permissions from "./mixins/Permissions";
import { directive as onClickOutside } from "vue-on-click-outside";
import VueConfirmDialog from "vue-confirm-dialog";

import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/js/plugins.pkgd.min";
// custom plugins
import "./froala-plugins/rocket-link/rocket-link";
import "./froala-plugins/rocket-link/rocket-link.css";
import "./froala-plugins/rocket-paste";
import VueFroala from "vue-froala-wysiwyg";
import VTooltip from "v-tooltip";
import { createPinia, PiniaVuePlugin } from "pinia";

Vue.use(VueFroala);
Vue.use(VTooltip);

Vue.directive("on-click-outside", onClickOutside);
Vue.use(ServerTable, {}, false, require("./components/Table/themes/tailwind"));
Vue.use(VuePluralize);
Vue.use(Notifications);
Vue.mixin(Permissions);

Vue.use(VueConfirmDialog);
Vue.use(PiniaVuePlugin);
Vue.component("vue-confirm-dialog", VueConfirmDialog.default);

const pinia = createPinia();

const files = require.context("./", true, /\.vue$/i);
files
    .keys()
    .map((key) =>
        Vue.component(key.split("/").pop().split(".")[0], files(key).default)
    );

Vue.mixin({
    methods: {
        route: window.route,
        redirect(name, params, absolute) {
            window.location.href = this.route(name, params, absolute);
        },
        redirectRaw(url, newTab = false) {
            if (newTab) {
                window.open(url, "_blank");
            } else {
                window.location.href = url;
            }
        },
        selectObject(object) {
            this.$emit("selected", object);
        },
    },
});

const app = new Vue({
    el: "#app",
    pinia,
});

if (document.querySelector(".successFlashMessage")) {
    setTimeout(function () {
        document.querySelector(".successFlashMessage").classList.add("hidden");
    }, 5000);
}

let showMenuCheck = function (selector) {
        if (document.querySelector(selector)) {
            return document
                .querySelector("#category-container .hide")
                .classList.contains("block");
        }
        return false;
    },
    showMenus = {
        category: showMenuCheck("#category-container .hide"),
        legal_pages: showMenuCheck("#legal-pages-container .hide"),
        learning_hub: showMenuCheck("#learning-hub-container .hide"),
        data: showMenuCheck("#data-container .hide"),
        template: showMenuCheck("#template-container .hide"),
        pages: showMenuCheck("#pages-container .hide"),
        seo: showMenuCheck("#seo-container .hide"),
        exports: showMenuCheck("#exports-container .hide"),
        media: showMenuCheck("#media-container .hide"),
    };

if (document.querySelector("#data-container")) {
    document
        .querySelector("#data-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#template-container")) {
    document
        .querySelector("#template-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#category-container")) {
    document
        .querySelector("#category-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#pages-container")) {
    document
        .querySelector("#pages-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#legal-pages-container")) {
    document
        .querySelector("#legal-pages-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#learning-hub-container")) {
    document
        .querySelector("#learning-hub-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#seo-container")) {
    document
        .querySelector("#seo-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#exports-container")) {
    document
        .querySelector("#exports-container")
        .addEventListener("click", handleMenuClick);
}
if (document.querySelector("#media-container")) {
    document
        .querySelector("#media-container")
        .addEventListener("click", handleMenuClick);
}

function handleMenuClick(e) {
    let li = e.target.closest("li");
    let id = li.getAttribute("id");

    let div = li.nextElementSibling;

    let arrowDown = li.querySelector(`.show`);
    let arrowUp = li.querySelector(`.hide`);

    let keyName = id.replace("-container", "").replace(/\-/g, "_");

    showMenus[keyName] = !showMenus[keyName];

    if (showMenus[keyName]) {
        div.classList.add("block");
        div.classList.remove("hidden");

        arrowDown.classList.add("hidden");
        arrowDown.classList.remove("block");

        arrowUp.classList.add("block");
        arrowUp.classList.remove("hidden");
    } else {
        div.classList.add("hidden");
        div.classList.remove("block");

        arrowDown.classList.add("block");
        arrowDown.classList.remove("hidden");

        arrowUp.classList.add("hidden");
        arrowUp.classList.remove("block");
    }
}

/**
 * Language tabs cookies
 */
document.querySelectorAll("a[data-languageIso]").forEach((anchor) => {
    anchor.addEventListener(
        "click",
        () =>
            (document.cookie =
                "language-iso=" +
                anchor.dataset.languageiso +
                ";max-age=31536000;path=/;")
    );
});
